<template>
    <div class="row justify-content-center">
        <div v-if="requested" class="col justify-content-center text-center mb-3">
            <h5 class="text-white mt-5">
                {{ $t('message.requestSucceeded') }}
            </h5>

            <h6 class="text-white">
                {{ `${$t('message.restoreLetterSent')}:&nbsp;` }}<strong>{{ mail }}</strong>
            </h6>
        </div>

        <div v-else class="form-container d-flex flex-column align-items-center">
            <div class="card bg-transparent border-0">
                <div class="card-body">
                    <h2 class="title-text mx-auto mb-3">
                        {{ $t('title.passwordRecovery') }}
                    </h2>

                    <ValidationObserver ref="observer">
                        <v-input
                            v-model="mail"
                            class="input-w-default mb-0 mt-2"
                            type="text"
                            :debounce="500"
                            :placeholder="$t('placeholder.email')"
                            :icon="$getInputIcon(mail, 'email')"
                            rules="required|email|emailExists"
                            @keyEnterUp="restore"
                        />
                    </ValidationObserver>

                    <b-button class="restore-button w-75 mb-2" @click="restore">
                        {{ $t('button.restore') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VInput from './VInput';
    import api from '../api';

    export default {
        name: 'Restore',

        components: { VInput },

        data() {
            return {
                mail: '',
                requested: false
            };
        },

        methods: {
            async restore() {
                let isValid = await this.$refs.observer.validate();

                if (isValid) {
                    let response = await api.post('/app/registration/restore/request', { mail: this.mail });

                    if (response)
                        this.requested = true;
                }
            }
        }
    };
</script>

<style scoped>
    .title-text {
        font-weight: lighter !important;
        font-size: 23px;
        line-height: 27px;
        text-decoration: none !important;
        padding-bottom: 2px;
        border-bottom: 1px solid #FFFFFF;
        color: white;
        text-align: center;
        text-decoration-skip-ink: none;
    }

    .restore-button {
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        background-color: transparent !important;
        border: 1px solid #36AB71 !important;
        border-radius: 5px !important;
        margin-top: 1.7rem !important;
    }

    .restore-button:hover {
        background-color: #36AB71 !important;
    }
</style>
